let trayaProcessingAnimation = document.getElementById('traya-processing-animation');
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};
var id = getUrlParameter('id'), f_name, C_number, C_email, user__gender, user_gender, caseId, pdPrice = 0;;
var cohort = getUrlParameter('cohort'), factors = [];
if(id) {
  localStorage.setItem('user-gender', 'female');
  localStorage.setItem('rid', id);
}
id = localStorage.getItem('rid');
if(id == undefined) {
  id = getCookie('syntheticId');
}
(function() {
  if(!id) {
    if(window.location.pathname == '/pages/result4'){
      alert('Your recommendation is not found. Please fill the diagnosis to help us share the recommended plan.');
      document.location.href= 'https://form.traya.health/questions?cohort=1&source=ResultPage'
    }
  }else
    setotherCookie('syntheticId', id, 30, '.traya.health');
    var baseUrls = {
      DEV: 'https://api.dev.hav-g.in/',
      PROD: 'https://api.hav-g.in/'
    }
    var tokens = {
      DEV:{ 
        "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d"
      },
      PROD: { 
        "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
      }
    }
    var token = tokens.PROD;
    var baseUrl = baseUrls.PROD;
    var liveendpoint = 'https://api.hav-g.in/dgReport/female?id=';
    liveendpoint = `${baseUrl}dgReport/female?id=`
    getFemaleResult(liveendpoint, id, token);
})();

// CAPI_TRACKING_API code
function trackMetaEvent(response, eventName) {
  function getCookieValue(cookieName) {
    const cookie = document.cookie.split(';').find(c => c.trim().startsWith(cookieName + '='));
    if (!cookie) return null;
    return cookie.trim().split('=').slice(1).join('=');
  }
  
  const fbp = getCookieValue('_fbp');
  const fbc = getCookieValue('_fbc');
  const user_gender = response.gender;
  const email = response.email;
  const phone = response.phone;
  
  const capiBody = {
    eventName: eventName,
    eventTime: Date.now(),
    email: email,
    phone: phone,
    fbc: fbc,
    fbp: fbp,
    url: window.location.href,
    domain: "traya.health",
    gender: user_gender
  };
  
  const CAPI_TRACKING_API = {
    Dev: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  
  const bearerTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };
  
  fetch(`${CAPI_TRACKING_API.PROD}tracking`, { method: 'POST', body: JSON.stringify(capiBody), headers: {
      "Content-Type": "application/json",
      ...bearerTokens.PROD
    }
  });
}

function getFemaleResult(liveendpoint, id, token) {
  document.body.style.overflow = "hidden";
  fetch(`${liveendpoint}${id}`, {
    headers: token,
  })
    .then((response) => response.json())
    .then((response) => {
      if (
        response.message &&
        response.message === "Report is only for female"
      ) {
        const queryParams = window.location.search;
        window.location.href = `/pages/result4${queryParams}`;
        return;
      }

      showContent(response);
      trackMetaEvent(response.User_Analysis, "Viewed Content");
      rootCause(response?.root_causes);
    })
    .catch((error) => {
      console.error("Network Error: ", error);
    })
    .finally(() => {
      clearCart();
      document.body.style.overflow = "unset";
    });
}

function rootCause (response) {
  const primaryRootCause = response?.primaryRootCause ?? [];
  const defaultRootCause = response?.defaultRootCause ?? [];
  let primaryRootCauseHtml = '';
  let primaryRootCauseContentHtml = '';
  if (primaryRootCause.length > 0) {
    primaryRootCauseHtml = `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border active text-center" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tab" aria-controls="${primaryRootCause[0]?.title.replace(/ /g, "-")}" aria-selected="true">
        <div class="rootCauseLinkImg">
          <img src="${primaryRootCause[0]?.details?.icon}" width="32px" height="32px" loading="eager"/>
        </div>
        <p class="mt-2">${primaryRootCause[0]?.title}</p>
      </a>
    </li>`;
  }
  if (primaryRootCause.length > 0) {
    primaryRootCauseContentHtml = `<div class="tab-pane fade show active" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${primaryRootCause[0]?.details?.description?.english}</p>
    </div>`;
  }
  const defaultRootCauseHtml = defaultRootCause.map((item) => {
    return `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border text-center" id="${item?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${item?.title.replace(/ /g, "-")}" role="tab" aria-controls="${item?.title.replace(/ /g, "-")}" aria-selected="false">
        <div class="rootCauseLinkImg">
          <img src="${item?.details?.icon}" width="32px" height="32px" loading="eager"/>
        </div>
        <p class="mt-2">${item?.title}</p>
      </a>
    </li>`;
  }).join('');
  const defaultRootCauseContentHtml = defaultRootCause.map((item) => {
    return `<div class="tab-pane fade" id="${item?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${item?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${item?.details?.description?.english}</p></div>`;
  }).join('');
  const rootCauseHtml = `<ul class="nav rootCause-nav-tabs border-0" id="myTab" role="tablist">${primaryRootCauseHtml}${defaultRootCauseHtml}</ul>
  <div class="tab-content rootCauseTabContent p-2 p-md-3 mt-3" id="myTabContent">${primaryRootCauseContentHtml}${defaultRootCauseContentHtml}</div>`;
  const rootCauseSectionWrapper = document.getElementById('rootCouseSectionWrapper');
  if (rootCauseSectionWrapper) {
    rootCauseSectionWrapper.innerHTML = rootCauseHtml;
  }
}

function showContent(response) {
  var normalPage = document.querySelectorAll('[page_type="normal"]');
  var cuticlePage = document.querySelectorAll('[page_type="cuticle"]');
  var { User_Analysis, Recommendations, stageTransition, assessmentReport, hideAssesmentImage } = response;
  var RootCauses = response.root_causes.primaryRootCause[0];
  var User_Analysis_hair_fall =  User_Analysis.hair_fall_stage;
  const newHairFallStage = User_Analysis_hair_fall;
  const hairThinningWeekText = document.querySelector('.hair_thinning_week_text-container');
  const hairThinningWeekText2 = document.querySelector('.hair_thinning_week_text-container.d-md-none');
  const removeCustomPriceSection = document.querySelector('.custom-price-section');
  
  var tillImage = document.querySelector(".tillImage img"), toImage = document.querySelector(".toImage img"), toStageWiseimg = document.querySelector(".stageWise-img"),
    assist_report = document.querySelector(".assist_report strong"), mobileDescription = document.querySelector(".mobileDescription"),
     desktopDescription = document.querySelector(".desktopDescription");
    if (hideAssesmentImage === true) {
      if (toStageWiseimg) {
        toStageWiseimg.style.cssText = "display: none;";
      }
    } else {
      if(tillImage) tillImage.setAttribute("src", stageTransition.current);
      if(toImage) toImage.setAttribute("src", stageTransition.getYouHere);
    }
  if(User_Analysis_hair_fall.toLowerCase() === "coin size patches") {
    var toImageParent = document.querySelector(".toImage"), arrowImage = document.querySelector(".stageWise-img .arrow"), stageWiseimg = document.querySelector(".stageWise-img");
    if(toImageParent) toImageParent.classList.add("d-none");
    if(arrowImage) arrowImage.classList.add("d-none");
    if(stageWiseimg) stageWiseimg.classList.add("justify-content-center");
  }
  if(assist_report) assist_report.innerHTML = User_Analysis_hair_fall;
  const defaultText = "While coin size patches cannot be cured, we offer a kit to help maintain your hair. Results may be limited due to the advanced stage of female hair loss, but we are here to support you.";
  const isCoinSizePatches = User_Analysis_hair_fall.toLowerCase() === "coin size patches";
  const displayText = isCoinSizePatches
	? defaultText
	: assessmentReport?.assessmentReport?.replace(/\n/g, "<br>");
  if (mobileDescription) mobileDescription.innerHTML = displayText;
  if (desktopDescription) desktopDescription.innerHTML = displayText;
  if (User_Analysis_hair_fall == "No widening" || User_Analysis_hair_fall == "Starting to see widening") {
    let product_card_head = document.querySelectorAll(".product-section_heading-kit");
    product_card_head.forEach((e) => {
      if (window.innerWidth < 768) {
        e.innerHTML = "Your Customised <br> Hair Treatment Kit";
      } else {
        e.textContent = "Your Customised Hair Treatment Kit";
      }
    });
  }
  
  f_name = User_Analysis.first_name; 
  C_number = User_Analysis.phone; 
  setCookie('user_phone', C_number, 30)
  C_email = User_Analysis.email;
  user__gender = User_Analysis.gender;
  caseId = User_Analysis.case_id;
  localStorage.setItem('caseId', caseId);
  tagClarityCaseId(caseId);
  if(user__gender == 'F') {
    user_gender = 'Female';
  }
    productComboKit(response);
    bundleProducts(response);
    sectionMonthsExpectetion(response);
    sectionWomensStories(response);
  
    let goal = User_Analysis.goal;
    if(goal != null && goal != 'undefined'){
      goal = goal.replace('{"',"").replace(/","/g,", ").replace(/Anti-/g,'').replace(/More/g,'').replace('"}',"")
    }else {
     goal = 'Goal';
    }
    var root_cause = `Gut:${User_Analysis.gut}, Stress:${User_Analysis.stress}`, suffering_data = User_Analysis.suffering_from_conditions,
      hair_type = User_Analysis.hair_type, Stress = User_Analysis.stress, Genetics = User_Analysis.family_genetic,
      FamilyGenetics = User_Analysis.family_genetic, EnergyLevel = User_Analysis.energy_level, Digestion = User_Analysis.acidity_bloating_gas_indigestion,
      Lowthyroid = User_Analysis.suffering_from_conditions, vitamindefeciencies = User_Analysis.vitamin_defeciencies,
      show_treatment_months = response.show_treatment_months;
    if(show_treatment_months == true){
      var _newFresult = document.querySelectorAll('.new-fresult'), __customEssential = document.querySelectorAll('.custom-essential'),
        __female_concern_months = document.querySelectorAll('.female_concern_months'), __container_will_see = document.querySelectorAll('.container.will-see');
      if(_newFresult.length != 0) {showOrHideByClass(_newFresult, 'add', 'new-fresult_pd_true');}
      if(__customEssential.length != 0) {showOrHideByClass(__customEssential, 'add', 'custom_essential_pd_true');}
      if(__female_concern_months.length != 0) {
        showOrHideByClass(__female_concern_months, 'add', 'female_months_show');
        showOrHide(__female_concern_months, 'block');
      }
      if(__container_will_see.length != 0) {showOrHide(__container_will_see, 'none');}
    }
    var user__name = document.querySelectorAll('[data-user-name]'), __data_user_name_info = document.querySelectorAll('[data-user-name-info]'),
      scalpType = document.querySelectorAll('.femleBannerTTls [scalp-type]'), __hair_concern = document.querySelectorAll('.femleBannerTTls [hair-concern]'),
      __root__cause = document.querySelectorAll('.femleBannerTTls [root-cause]'), __primary_root = document.querySelectorAll('[primary-root]'),
      __mainFactImages = document.querySelectorAll('.root_cause_iconFR .mainFactImages'), __femaleMainFactImages = document.querySelectorAll('.root_cause_iconFRs .mainFactImages'),
      __rootcause_description = document.querySelectorAll('.RootCause .rootcause_description'), __formulation = document.querySelectorAll('.formulation .formulation-text');
    if(user__name.length != 0){user__name.forEach((name) => {name.textContent = `${User_Analysis.first_name}`});}
    if(__data_user_name_info.length != 0) {__data_user_name_info.forEach((info) => {info.textContent = `${User_Analysis.first_name}'s`})}
    if(scalpType.length != 0) {scalpType.forEach((scalp) => {scalp.textContent = `${User_Analysis.hair_type}`})}
    if(__hair_concern.length != 0) {__hair_concern.forEach((concern) => {concern.textContent = `${goal}`})}
    if(__root__cause.length != 0) {__root__cause.forEach((cause) => {cause.textContent = `${factors[0]}`})}
    if(__primary_root.length != 0) {__primary_root.forEach((root) => {root.textContent = `${factors[0]}`})}
    if(__mainFactImages.length != 0) {showOrHide(__mainFactImages, 'none');}
  
    var ATC_frp = document.querySelectorAll('#add-to-cart-result-page-frp'), stickyATC_frp = document.querySelectorAll('.sticky-btn #add-to-cart-result-page-frp'),
      ATC_rp = document.querySelectorAll('.add-to-cart-result-page');
    if(ATC_frp.length != 0) {
      ATC_frp.forEach((rp) => {
        rp.setAttribute('user-mobile', User_Analysis.phone);
        rp.setAttribute('user-email', User_Analysis.email);
      });
    }
    if(stickyATC_frp.length != 0) {
      stickyATC_frp.forEach((rp) => {
        rp.setAttribute('user-mobile', User_Analysis.phone);
        rp.setAttribute('user-email', User_Analysis.email);
      });
    }
    if(ATC_rp.length != 0) {
      ATC_rp.forEach((rp) => {
        rp.setAttribute('user-mobile', User_Analysis.phone);
        rp.setAttribute('user-email', User_Analysis.email);
      });
    }
  
  let buyButtonElement = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtonElement.forEach((eachBtn) => {
    eachBtn.addEventListener('click', () => {
      eachBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_clockwise.svg?v=1746524502" class="loader-icon" alt="Loading...">`;
      eachBtn.classList.add('loader-added')
      eachBtn.disabled = true;
      trackMetaEvent(response.User_Analysis, "Expand Benefits");
    });
  });
  if (trayaProcessingAnimation) {
    trayaProcessingAnimation.style.display = 'none';
  }
  document.body.style.overflow = 'unset';
}

function removeLoader() {
  let buyButtonLoader = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtonLoader.forEach((eachBtn) => {
    eachBtn.innerHTML = "Buy Now";
    eachBtn.classList.remove('loader-added')
    eachBtn.disabled = false;
 });
}
  
function showOrHide(partition, state) {
  partition.forEach((part) => {
    part.style.display = `${state}`;
  })
}

function showOrHideByClass(partition, work, state) {
  partition.forEach((part) => {
    if(work == 'add') {part.classList.add(state)}
    if(work == 'remove') {part.classList.remove(state)}
  })
}

const popOneLinerData = [
  {
    product: "Defence conditioner 50g",
    effect:
      "Defence conditioner improves hair quality by deeply moisturizing the hair strands",
  },
  {
    product: "Defence Shampoo 100ml",
    effect: "Defence Shampoo ensures hair hygiene for a healthy scalp.",
  },
  {
    product: "Shine Leave-in Serum",
    effect: "Shine Serum enhances hair texture for a vibrant, healthy look.",
  },
  {
    product: "Hair Vitamin For Her",
    effect:
      "Hair Vitamin addresses nutritional deficiency to reduce hair fall.",
  }
];

const bundleMap = {
  bundle1: [
    {
      "variantId": "47300731568306",
      "name": "Hair Actives Serum",
      "tag": "Control Hair Fall",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Product_3.webp?v=1752835061",
      "one_liner": "Clinically Proven Hair Growth Actives",
      "price": "799"
    },
    {
      "variantId": "43480049516722",
      "name": "Nourish Hair Oil",
      "tag": "Scalp Health",
      "image_url": "http://dvv8w2q8s3qot.cloudfront.net/products/product_single_images/nourish_hair_oil.png",
      "one_liner": "Nourishes Hair for Strength & Shine",
      "price": "499"
    },
    {
      "variantId": "45026321039538",
      "name": "Hair Santulan 03",
      "tag": "Hair Fall",
      "image_url": "http://dvv8w2q8s3qot.cloudfront.net/products/product_single_images/HairSantulan03.png",
      "one_liner": "Natural Herbs for Hair Nourishment",
      "price": "750"
    },
    {
      "variantId": "45277154377906",
      "name": "Defence conditioner 50g",
      "tag": "Hair Texture",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Product_image_assets.png?v=1750940636",
      "one_liner": "Conditions and Smoothens Hair Texture",
      "price": "0"
    }
  ],
  bundle2: [
    {
      "variantId": "47300731568306",
      "name": "Hair Actives Serum",
      "tag": "Control Hair Fall",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Product_3.webp?v=1752835061",
      "one_liner": "Clinically Proven Hair Growth Actives",
      "price": "799"
    },
    {
      "variantId": "43480049516722",
      "name": "Nourish Hair Oil",
      "tag": "Scalp Health",
      "image_url": "http://dvv8w2q8s3qot.cloudfront.net/products/product_single_images/nourish_hair_oil.png",
      "one_liner": "Nourishes Hair for Strength & Shine",
      "price": "499"
    },
    {
      "variantId": "45021653696690",
      "name": "Hair Ras 06",
      "tag": "Hair Fall",
      "image_url": "http://dvv8w2q8s3qot.cloudfront.net/products/product_single_images/HairRas06.png",
      "one_liner": "Natural Herbs for Hair Nourishment",
      "price": "750"
    },
    {
      "variantId": "45277154377906",
      "name": "Defence conditioner 50g",
      "tag": "Hair Texture",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Product_image_assets.png?v=1750940636",
      "one_liner": "Conditions and Smoothens Hair Texture",
      "price": "0"
    }
  ],
  bundle3: [
    {
      "variantId": "45277154377906",
      "name": "Defence conditioner 50g",
      "tag": "Hair Texture",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Product_image_assets.png?v=1750940636",
      "one_liner": "Conditions and Smoothens Hair Texture",
      "price": "0"
    },
    {
      "variantId": "44422009323698",
      "name": "Defence Shampoo 100ml",
      "tag": "Hair Texture",
      "image_url": "http://dvv8w2q8s3qot.cloudfront.net/products/product_single_images/defence_shampoo_180ml.png",
      "one_liner": "SLS free shampoo for pH balance",
      "price": "300"
    },
    {
      "variantId": "47301148803250",
      "name": "Shine Leave-in Serum",
      "tag": "Hair Texture",
      "image_url": "http://dvv8w2q8s3qot.cloudfront.net/products/product_single_images/shine_serum.png",
      "one_liner": "Makes Hair Strong, Silky & Shiny",
      "price": "800"
    },
    {
      "variantId": "44127491063986",
      "name": "Hair Vitamin For Her",
      "tag": "nutrition",
      "image_url": "https://dvv8w2q8s3qot.cloudfront.net/products/product_single_images/hair_vitamin_for_her.png",
      "one_liner": "Vitamin supplement to promote healthy hair growth",
      "price": "520"
    }
  ]
};

async function productComboKit(response) {
  const userProductIds = response.product_Ids.map(p => p.product_id);
  const proDetEle = document.querySelector('.product-combo-details');
  proDetEle.innerHTML = '';
  
  let selectedBundleKey = '';
  if (userProductIds.includes("45026321039538")) {
    selectedBundleKey = 'bundle1';
  } else if (userProductIds.includes("45021653696690")) {
    selectedBundleKey = 'bundle2';
  }
  const selectedBundle = bundleMap[selectedBundleKey];
  if (!selectedBundle) return;
  
  const containerDiv = document.createElement('div');
  containerDiv.classList.add('kit-container', 'container');
  if (window.innerWidth <= 767) containerDiv.classList.remove('container');
  proDetEle.appendChild(containerDiv);
  let total = 0;
  
  selectedBundle.forEach((prod) => {
    const productDiv = document.createElement('div');
    productDiv.classList.add('kit-card-container');
    productDiv.dataset.productId = prod.variantId;

    productDiv.innerHTML = `
      <div class="reco-pro reco-product-combo">
        <div class="box-separator-line">
          <div class="hairthinning-combo-kit-wrapper">
            ${prod.variantId === "45277154377906" ?
              `<div class="free-product-badge">
                <img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/free_product_gift.webp?v=1743688549" alt="Free Product Tag" width="24px" height="24px" loading="lazy" class="p-image"/>
                <p class="free-gift-product">Here’s your Freebie</p>
              </div>`
              : ''}
            <div class="hairthinning-combo-kit-container">
              <div class="p-image-container">
                <img src="${prod.image_url}" alt="${prod.name}" width="100" height="100" loading="lazy" class="p-image" />
              </div>
              <div class="prod-content-wrapper">
                <div class="p-content-container">
                  <div class="p-title-tag-container">
                    <h2 class="p-title">${prod.name}</h2>
                  </div>
                  <div class="p-price-container">
                    <p class="p-price text-center">${prod.variantId === "45277154377906" ? `<del>₹199 </del>` : `₹${Math.round(prod.price)}`}</p>
                  </div>
                </div>
                <p class="liner-text">${prod.one_liner}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    containerDiv.appendChild(productDiv);
    
    total += Math.round(prod.price);
    document.querySelectorAll('.total-price').forEach(el => {
      el.textContent = `₹ ${Math.round(total).toLocaleString('en-IN')}`;
      
    });
    variantsIDs.push({
      id: prod.variantId,
      quantity: 1,
      ...(getCookie("GuestForm_id") && {
        properties: { _result_id: id }
      })
    });
    
  });
}

function fireEvent(eventName, caseID, productId, productName) {
  const attributes = {
    platform: "web_shopify",
    domain: "traya.health",
    syntheticId: window.location.search.substring(1).split('=')[1] || "default-id"
  };

  if (productId) {
    attributes.productId = productId;
  }

  if (productName) {
    attributes.productName = productName;
  }
  const baseAPI = {
    Dev: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  const baseTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };
  fetch(`${baseAPI.PROD}eventMoengageWeb`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...baseTokens.PROD
    },
    body: JSON.stringify({
      eventName: eventName,
      eventAttributes: {
        generalAttributes: attributes
      },
      caseId: caseID
    })
  });
}


async function bundleProducts(response) {
  const userProductIds = response.product_Ids.map(p => p.product_id);
  let selectedBundleKey = '';
  if (userProductIds.includes("45026321039538")) {
    selectedBundleKey = 'bundle1';
  } else if (userProductIds.includes("45021653696690")) {
    selectedBundleKey = 'bundle2';
  }

  const firstBundleSlider = document.querySelector('.first-bundle-products');
  const secondBundleSlider = document.querySelector('.second-bundle-products');
  
  if (selectedBundleKey === 'bundle1') {
    firstBundleSlider?.classList.remove('d-none');
    secondBundleSlider?.classList.add('d-none');
  } else if (selectedBundleKey === 'bundle2') {
    secondBundleSlider?.classList.remove('d-none');
    firstBundleSlider?.classList.add('d-none');
  }

  let productBlockImage = document.querySelectorAll('.female-bundle-produdct--image');
  if (productBlockImage.length > 1) {
    $(".female-bundle-products-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 5000,
      arrows: true,
      dots: true,
      infinite: true,
      centerMode: true,
      centerPadding: "10px",
    });
  }

  const bundleProductData = bundleMap[selectedBundleKey] || [];
  const editableProductData = bundleMap['bundle3'] || [];
  
  let bundleProductContainer = document.querySelector('.female-bundle-products-list-wrapper');
  bundleProductData.forEach((each) => {
    const bundleProduct = document.createElement('div');
    bundleProduct.classList.add('bundle-product-card');
    bundleProduct.dataset.productId = each.variantId;

    if (each.variantId !== "45277154377906") {
      bundleProduct.innerHTML = `
        <div class="bundle-product-wrapper">
          <div class="bundle-product-flex">
            <div class="bundle-product-image">
              <img src="${each.image_url}" alt="${each.name}" width="84px" height="84px" loading="lazy" class="p-image"/>
            </div>    
            <div class="bundle-product-content">
              <div class="bundle-product-title-container">
                <h2 class="bundle-product-title">${each.name}</h2>
              </div>
              <p class="bundle-product-liner-text">${each.one_liner}</p>
              <div class="bundle-product-price-container">
                <p class="p-price text-center">${each.product_id === "45277154377906" ? `<del>₹199 </del>` : `₹${Math.round(each.price)}`}</p>
              </div>
            </div>
          </div>
        </div>`;
      bundleProductContainer.appendChild(bundleProduct);
    }
  });

  let editableProductContainer = document.querySelector('.editable-bundle-products-list-wrapper');
  const skipProductIds = ['37546421289138', '47300731568306', '43480049516722'];

  editableProductData.forEach((each) => {
    if (!skipProductIds.includes(each.variantId)) {
      const editableProduct = document.createElement('div');
      editableProduct.classList.add('bundle-product-card-editable');
      editableProduct.dataset.productId = each.variantId;
      editableProduct.innerHTML = `
        <div class="bundle-product-flex ${each.variantId === '45277154377906' ? 'free-product-enjoy' : ''}">
          ${each.variantId === "45277154377906" ?
            `<div class="free-product-badge">
              <img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/free_product_gift.webp?v=1743688549" alt="Free Product Tag" width="24px" height="24px" loading="lazy" class="p-image"/>
              <p class="free-gift-product">Your Freebie</p>
            </div>` : ''
          }
          <div class="bundle-product-image">
            <img src="${each.image_url}" alt="${each.name}" width="84px" height="84px" loading="lazy" class="p-image"/>
          </div>    
          <div class="bundle-product-content">
            <div class="bundle-product-title-container">
              <h2 class="bundle-product-title">${each.name}</h2>
              <p class="bundle-product-liner-text">${each.one_liner}</p>
            </div>
            <div class="bundle-product-price-container">
              <p class="bundle-product--price">
                ${each.variantId === "45277154377906" ? `<del>₹199 </del> <strongred>FREE<strongred>` : `₹${Math.round(each.price || 0)}`}
              </p>
            </div>
            <button class="add-recommended-product ${each.variantId === '45277154377906' ? 'd-none' : 'dummyshow'}"
                    data-variant-id="${each.variantId}" data-product-name="${each.name}" data-product-image="${each.image_url}">Add to Cart</button>
            <button class="remove-recommended-product product-remove-btn ${each.variantId === '45277154377906' ? 'dummyshow' : 'd-none'}"
                    data-variant-id="${each.variantId}" data-product-name="${each.name}" data-product-image="${each.image_url}">Remove</button>
          </div>
        </div>`;
      editableProductContainer.appendChild(editableProduct);
    }
  });

  // STEP 1
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-remove-btn');
    if (!btn) return;
  
    const productName = btn.getAttribute('data-product-name');
    const productImage = btn.getAttribute('data-product-image');
    updateRemovePopupContentByProduct(productName, productImage);
  
    selectedVariantId = btn.getAttribute('data-variant-id');
    selectedProductElement = document.querySelector(`.kit-card-container[data-product-id="${selectedVariantId}"]`);
  
    fireEvent("remove_clicked", caseId, selectedVariantId, productName);
  
    const removePopup = document.getElementById('remove-confirmation-popup');
    removePopup.classList.add('popup-visible');
  });
  // STEP 2
  document.querySelector('.remove-popup-remove-btn').addEventListener('click', async function () {
    if (!selectedVariantId) return;
  
    const removeBtn = this;
    removeBtn.innerHTML = `
      <img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_3.svg?v=1741241123"
           class="loader-icon" alt="Loading..." style="width: 20px; height: 20px;" />`;
  
    try {
      const cart = await fetch('/cart.js').then(res => res.json());
      const lineItem = cart.items.find(item => item.variant_id == selectedVariantId);
      if (!lineItem) return;
  
      const productName = lineItem.product_title;
      await removeCartItemByKey(lineItem.key);
  
      const cards = document.querySelectorAll(`.bundle-product-card-editable[data-product-id="${selectedVariantId}"]`);
      cards.forEach((card) => {
        const removeBtn = card.querySelector('.remove-recommended-product');
        const addBtn = card.querySelector('.add-recommended-product');
        removeBtn.classList.add('d-none');
        addBtn.classList.remove('d-none');
      });
  
      const kitCard = document.querySelector(`.product-combo-details .kit-card-container[data-product-id="${selectedVariantId}"]`);
      if (kitCard) {
        kitCard.classList.add('fade-out');
        setTimeout(() => {
          kitCard.remove();
        }, 300);
      }
  
      fireEvent("product_removed", caseId, selectedVariantId, productName); 
      document.getElementById('remove-confirmation-popup').classList.remove('popup-visible');
      updateCartDrawer();
  
      try {
        const updatedCartRes = await fetch('/cart.js');
        if (!updatedCartRes.ok) throw new Error("Failed to fetch updated cart");
  
        const updatedCart = await updatedCartRes.json();
        if (!updatedCart || !updatedCart.items) throw new Error("Invalid cart format");
  
        const newTotal = updatedCart.items.reduce((sum, item) => sum + item.final_line_price, 0);
        document.querySelectorAll('.total-price').forEach(el => {
          el.textContent = `₹ ${Math.round(newTotal / 100).toLocaleString('en-IN')}`;
        });
      } catch (error) {
        console.error("Error fetching updated cart total:", error);
      }
  
      removeBtn.innerHTML = `Remove`;
    } catch (err) {
      console.error('Error removing product:', err);
    }
  });

  // STEP 3
  document.querySelector('.remove-popup-keep-btn').addEventListener('click', function () {
    selectedProductElement = null;
    selectedVariantId = null;
    document.getElementById('remove-confirmation-popup').classList.remove('popup-visible');
  });
  
  // STEP 4 add to cart
  document.addEventListener('click', async function (e) {
    const addBtn = e.target.closest('.add-recommended-product');
    if (!addBtn) return;
  
    const variantId = addBtn.getAttribute('data-variant-id');
    const productName = addBtn.getAttribute('data-product-name');
    const productImage = addBtn.getAttribute('data-product-image');
  
    addBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_3.svg?v=1741241123"
           class="loader-icon" alt="Loading..." style="width: 24px; height: 24px;" />`;
    addBtn.disabled = true;
    addBtn.classList.add('disabled');
  
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {}
        })
      });
  
      if (!res.ok) throw new Error('Add to cart failed');
      
      const cards = document.querySelectorAll(`.bundle-product-card-editable[data-product-id="${variantId}"]`);
      cards.forEach((card) => {
        const removeBtn = card.querySelector('.remove-recommended-product');
        const addBtn = card.querySelector('.add-recommended-product');
        addBtn.classList.add('d-none');
        removeBtn.classList.remove('d-none');
        addBtn.innerHTML = `Add to Cart`;
        addBtn.disabled = false;
        addBtn.classList.remove('disabled');
      });
  
      const restoredProduct = bundleMap.bundle3.find(p => p.variantId === variantId);
      if (restoredProduct) {
        const productDiv = document.createElement('div');
        productDiv.classList.add('kit-card-container', 'fade-in');
        productDiv.dataset.productId = variantId;
  
        productDiv.innerHTML = `
           <div class="reco-pro reco-product-combo">
            <div class="box-separator-line">
              <div class="hairthinning-combo-kit-wrapper">
                ${restoredProduct.variantId === "45277154377906" ?
                  `<div class="free-product-badge">
                    <img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/free_product_gift.webp?v=1743688549" alt="Free Product Tag" width="24px" height="24px" loading="lazy" class="p-image"/>
                    <p class="free-gift-product">Here’s your Freebie</p>
                  </div>`
                  : ''}
                <div class="hairthinning-combo-kit-container">
                  <div class="p-image-container">
                    <img src="${restoredProduct.image_url}" alt="${restoredProduct.name}" width="100" height="100" loading="lazy" class="p-image" />
                  </div>
                  <div class="prod-content-wrapper">
                    <div class="p-content-container">
                      <div class="p-title-tag-container">
                        <h2 class="p-title">${restoredProduct.name}</h2>
                      </div>
                      <div class="p-price-container">
                        <p class="p-price text-center">${restoredProduct.variantId === "45277154377906" ? `<del>₹199 </del>` : `₹${Math.round(restoredProduct.price)}`}</p>
                      </div>
                    </div>
                    <p class="liner-text">${restoredProduct.one_liner}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>`;
  
        const comboContainer = document.querySelector('.kit-container.container');
        if (comboContainer) {
          setTimeout(() => {
            comboContainer.appendChild(productDiv);
          }, 50);
        }
      }
  
      updateCartDrawer();
  
      const updatedCart = await fetch('/cart.js').then(res => res.json());
      const newTotal = updatedCart.items.reduce((sum, item) => sum + item.final_line_price, 0);
      document.querySelectorAll('.total-price').forEach(el => {
        el.textContent = `₹ ${Math.round(newTotal / 100).toLocaleString('en-IN')}`;
      });
  
      fireEvent("add_to_cart_clicked", caseId, variantId, productName);
    } catch (err) {
      console.error('Error adding to cart:', err);
    }
  });
}

function updateRemovePopupContentByProduct(productName, productImage) {
  const normalizedName = productName.trim().toLowerCase();
  const matched = popOneLinerData.find(item => item.product.trim().toLowerCase() === normalizedName);

  const titleElement = document.querySelector('.remove-popup-title');
  const imageElement = document.querySelector('.remove-popup-image');

  if (matched) {
    if (titleElement) titleElement.textContent = matched.effect;
    if (imageElement) imageElement.src = productImage || 'fallback.jpg';
  } else {
    if (titleElement) titleElement.textContent = "Are you sure you want to remove this item?";
  }
}

function removeCartItemByKey(lineItemKey) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineItemKey, quantity: 0 })
  })
  .then(res => res.json())
  .then(cart => {
    updateCartDrawer();    
  })
  .catch(err => console.error('Error removing item:', err));
}

function bindCartDrawerEvents() {
  const closeBtn = document.querySelector('.drawer__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      document.querySelector('cart-drawer.drawer')?.classList.remove('active');
      document.querySelector('.cart-drawer__overlay')?.classList.remove('active');
    });
  }
}

// timeline section 
function sectionMonthsExpectetion(response) {
  let { monthsExpectation } = response;
  if (monthsExpectation.monthExpectations && monthsExpectation.showComponent == true) {
    const timeline = document.getElementById('timeline');
    monthsExpectation.monthExpectations.forEach((month, index) => {
        const block = document.createElement('div');
        block.className = 'timeline-block';
        block.innerHTML = `
            <div class="timeline-icon">
              <img src="${month.image_url}" alt="Month ${month.month}"  width="100px" height="100px" loading="lazy">
            </div>
            ${index < monthsExpectation.monthExpectations.length - 0 ? `
              <div class="timeline-dot-line">
                <div class="timeline-dot"></div>
                <div class="timeline-line"></div>
              </div>
            ` : ''}
            <div class="timeline-content">
              <p><strong>Month ${month.month}</strong></p>
              <p class="monthe-suggestion">${month.goal}</p>
            </div>
        `;
       timeline.appendChild(block);
    });

    if (timeline) {
      $(timeline).slick({
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
      });
      if ($(window).width() < 768) {
        $(timeline).slick('unslick');
      }
      if (monthsExpectation.monthExpectations.length <= 4) {
        timeline.classList.add('minus-the-margin');
        $(timeline).slick('unslick');
      }
    }
  }
}
// timeline section end

// doctor recomandation section 
function sectionBlocksDisplay(response) {
  let { User_Analysis } = response;
  let stage = User_Analysis.hair_fall_stage;
  const apiSection = document.querySelector('.static-block-container');
  const staticSection = document.querySelector('.block-container');

  const isDesktop = window.matchMedia('(min-width: 768px)').matches;

  if (stage == "No widening" || stage == "Starting to see widening") {
    apiSection.style.display = 'none';
    staticSection.style.display = isDesktop ? 'flex' : 'block';
  } else {
    apiSection.style.display = isDesktop ? 'flex' : 'block';
    staticSection.style.display = 'none';
  }
}
// doctor recomandation section end

// women's stories section function
function sectionWomensStories(response) {
  let { successStories } = response;
  if (successStories.stories && successStories.showComponent == true) {
    const imgCarousel = document.querySelector('.image-carousel');
    const titleElement = document.querySelector('.stories-main-heading');

    titleElement.textContent = 'Real Women, Real Stories';

    successStories.stories.forEach((storyUrl) => {        
      const imgCarouselBlock = document.createElement('div');
      imgCarouselBlock.className = 'image-carousel-container';
      imgCarouselBlock.innerHTML = `
        <div class="image-carousel--container-img position-relative mx-2">
          <img src="${storyUrl}" alt="Success Story" height="auto" width="auto" loading="lazy" >
        </div>
      `;
      imgCarousel.appendChild(imgCarouselBlock);
    });

    $(imgCarousel).slick({
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false, 
      dots: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "15px",
            dots: true,
          },
        },
      ],
    });
  }
}
// women's stories section function end

// Function to determine if the device is mobile
function isMobileDevice() {
  return window.innerWidth <= 767;
}

// Function to create and display popup with product details
function createProductPopup(productId) {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  const popupContentPlaceholder = document.getElementById('popup-content-placeholder');
  const siteUrl = {
    dev: { 
      "Link": "formv2s.dev.hav-g.in"
    },
    prod: { 
      "Link": "form.traya.health"
    }
  };

  const iframeUrl = `https://${siteUrl.prod.Link}/product-drawerv2/${productId}`;
  
  popupContentPlaceholder.innerHTML = `
    <iframe src="${iframeUrl}" frameborder="0" width="100%" height="100%"></iframe>
  `;
  
  if (isMobileDevice()) {
    popup.style.bottom = '0';
  } else {
    popup.style.right = '0';
  }

  overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';
  
  const closeIcon = document.getElementById('close-popup');
  closeIcon.addEventListener('click', function() {
    closeProductPopup();
  });

  overlay.addEventListener('click', function() {
    closeProductPopup();
  });
}

// Function to close the popup
function closeProductPopup() {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  
  if (isMobileDevice()) {
    popup.style.bottom = '-100%';
  } else {
    popup.style.right = '-100%';
  }

  overlay.style.display = 'none';
  document.body.style.overflow = '';
}

// Event delegation to handle click on product cards
document.querySelector('.female-bundle-products-list-wrapper').addEventListener('click', function(event) {
  if (event.target.closest('.dummyshow, .remove-recommended-product')) {
    return;
  }
  const reco = event.target.closest('.bundle-product-card');
  if (reco) {
    const productId = reco.getAttribute('data-product-id');
    createProductPopup(productId);
  }
});

document.querySelector('.editable-bundle-products-list-wrapper').addEventListener('click', function(event) {
  if (event.target.closest('.dummyshow, .remove-recommended-product, .add-recommended-product')) {
    return;
  }
  const reco = event.target.closest('.bundle-product-card-editable');
  if (reco) {
    const productId = reco.getAttribute('data-product-id');
    createProductPopup(productId);
  }
});

window.addEventListener('DOMContentLoaded', function() {
  var normalRpATC = document.querySelectorAll('#add-to-cart-result-page-frp');
  if(normalRpATC.length != 0) {
    normalRpATC.forEach((Rp) => {
      Rp.addEventListener('click', function() {
        // ATCFunction();
        setTimeout(() => {
            window.location.href = '/checkout';
        }, 200); 
        setTimeout(() => {
          removeLoader();
        }, 2000);
      });
    })
  }
});

var clearCart = function() {
  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    dataType: 'json',
    success: function() {
      let buyButtonElement = document.querySelectorAll('#add-to-cart-result-page-frp');
      buyButtonElement.forEach((eachBtn) => {
        eachBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_clockwise.svg?v=1746524502" class="loader-icon" alt="Loading...">`;
        eachBtn.classList.add('loader-added')
        eachBtn.disabled = true;
      })
      setTimeout(() => {
        checkout();
      }, 100);
    },
    error: function(error) {
      console.error('Error on first clear:', error);
    }
  });
}

function updateCartDrawer() {
  // Step 1: Get current cart contents
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const updates = {};

      cart.items.forEach(item => {
        if (item.quantity === 2) {
          updates[item.key] = 1; // Reduce quantity to 1 if it is exactly 2
        }
      });

      // Step 2: If any item needs update, call /cart/update.js in bulk
      if (Object.keys(updates).length > 0) {
        const body = {
          updates: updates
        };

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        })
        .then(res => res.json())
        .then(() => {
          // Step 3: Proceed to update UI (cart bubble + drawer)
          refreshCartUI();
        })
        .catch(err => console.error('Error updating quantities:', err));
      } else {
        // No updates needed, just refresh UI
        refreshCartUI();
      }
    });
}

function refreshCartUI() {
  // Update cart bubble
  fetch('/?sections=cart-icon-bubble')
    .then(res => res.json())
    .then(data => {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble && data['cart-icon-bubble']) {
        cartIconBubble.innerHTML = data['cart-icon-bubble'];
      }
    });

  // Update cart drawer section
  fetch('/?sections=cart-drawer')
    .then(res => res.json())
    .then(data => {
      const cartDrawerHTML = data['cart-drawer'];
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawerHTML) {
        cartDrawer.outerHTML = cartDrawerHTML;

        // Rebind events AFTER new drawer is in DOM
        setTimeout(() => {
          bindCartDrawerEvents?.();
        }, 50);

        // Optional: Hide quantity and remove button
        document.querySelectorAll('.cart-drawer .cart-item cart-remove-button, .cart-drawer quantity-input.quantity').forEach(el => {
          el.style.display = 'none';
        });
      }
    })
    .catch(err => console.error('Error updating cart drawer:', err));
}

function checkout() {
    localStorage.setItem('user__gender', user_gender);
  localStorage.setItem('caseId', caseId);

  variantsIDs.forEach(e => {
    e.properties = { 'Plan': 'Auto' };
  });

  const formData = {
    items: variantsIDs,
    attributes: {
      first_name: f_name,
      phone: C_number,
      email: C_email,
      caseid: caseId
    }
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(result => {
    localStorage.setItem('User_location', 'cart');
    console.log("Silent checkout complete");
  })
  .catch(error => {
    console.error('Silent checkout error:', error);
  })
  .finally(()=>{
    updateCartDrawer();
    setTimeout(() => {
      removeLoader();
    }, 400);
  });
}

function ATCFunction() {
  fetch('/cart/clear.js', {
    method: 'POST'
  }).then((response) => {
    return response.json();
  }).then((res) => {
    
  }).catch((error) => {
    console.error('Clear Cart Error: ', error);
  }).finally(() => {
    checkout();
    const addToCartEvent = 'result_add_to_cart';
    const addToCartEventData = { "gender": "Female"};
    Shopify.analytics.publish(addToCartEvent, addToCartEventData);
  })
}

window.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.cart-drawer .cart-item cart-remove-button, .cart-drawer quantity-input.quantity').forEach(el => {
    el.style.display = 'none';
  });

  var stickyBtn = document.querySelector('[sticky__btn]');

  if (stickyBtn) {
    stickyBtn.style.display = 'block';
    stickyBtn.style.position = 'fixed';
    stickyBtn.style.bottom = '0';
    stickyBtn.style.right = '0';
    // stickyBtn.style.zIndex = '9999';
  }
  
  var stickyBtn = document.querySelector('[btn_sticky]');

  if (stickyBtn) {
    stickyBtn.style.display = 'block';
    stickyBtn.style.position = 'fixed';
    stickyBtn.style.bottom = '0';
    stickyBtn.style.right = '0';
    // stickyBtn.style.zIndex = '9999';
  }
  const stickyButton = document.querySelector('.template-page.female-result [sticky__btn]');
  const stickyButtonCuticle = document.querySelector('.template-page.female-result [btn_sticky]');
  const addToCartButton = document.getElementById('add-to-cart-result-page-frp');
  
  const addZIndex = (element) => {
    if (element) {
      element.style.zIndex = '9999';
    }
  };

  const removeZIndex = (element) => {
    if (element) {
      element.style.zIndex = '';
    }
  };

  const handleAddToCartClick = () => {
    if (window.matchMedia("(min-width: 768px)").matches) {
      if (stickyButton && stickyButton.style.zIndex === '9999') {
        removeZIndex(stickyButton);
      } else {
        addZIndex(stickyButton);
      }
    }
  };

  if (window.matchMedia("(min-width: 768px)").matches) {
    addZIndex(stickyButton);
  }

  if (addToCartButton) {
    addToCartButton.addEventListener('click', function() {
      handleAddToCartClick();
    });
  }
  
  window.addEventListener('resize', () => {
    if (window.matchMedia("(min-width: 768px)").matches) {
      addZIndex(stickyButton);
    } else {
      removeZIndex(stickyButton);
    }
  });
});